import { render, staticRenderFns } from "./UpsertQuotaForm.vue?vue&type=template&id=27fddef7&scoped=true&"
import script from "./UpsertQuotaForm.vue?vue&type=script&lang=js&"
export * from "./UpsertQuotaForm.vue?vue&type=script&lang=js&"
import style0 from "./UpsertQuotaForm.vue?vue&type=style&index=0&id=27fddef7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fddef7",
  null
  
)

export default component.exports